<template>
    <div class="h-full">
        <iframe :src="url" width="100%" height="100%" frameborder="0" allowtransparency allowfullscreen v-if="url"></iframe>
    </div>
</template>

<script>
    export default {
        name: 'SalesDashboard',
        data () {
            return {
                url: null,
            }
        },
        mounted() {
            this.setMetaTitle('JournoLink Control')
            this.loadData()
        },
        methods: {
            /**
             * Load the Metabase embed URL from the Controller.
             *
             * @return {void}
             */
            loadData () {
                axios.get(route('sales-dashboard'))
                    .then(response => {
                        this.url = response.data.url
                    })
                    .catch(e => {
                        console.error(e)
                    })
            },
        },
    }
</script>
